import { render } from "./RecommendPointRank3.vue?vue&type=template&id=4ce6c5d1&scoped=true"
const script = {}

import "./RecommendPointRank3.vue?vue&type=style&index=0&id=4ce6c5d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce6c5d1"]])

export default __exports__